export default __webpack_public_path__ + "static/media/shopee.a5eb60c5.png";